import React, { useContext, useEffect, useState } from 'react'
import { Auth } from 'aws-amplify'
import { Input, Text } from '@/style-guide'
import { Form, Button } from 'antd'
import { AuthContext } from '../AuthContext'

export const ConfirmSignUp = () => {
  const { payload, onSuccess } = useContext(AuthContext)
  const [form] = Form.useForm()
  const [isLoading, setLoading] = useState(false)
  const [isValidatingCode, setValidatingCode] = useState(false)
  const [codeSent, setCodeSent] = useState(false)
  const [codeMessage, setCodeMessage] = useState({})

  useEffect(() => {
    if (codeSent)
      setTimeout(() => {
        setCodeSent(false)
        setCodeMessage({})
      }, [120 * 1000])
  }, [codeSent])

  const resendCode = async () => {
    try {
      setValidatingCode(true)
      setCodeMessage({})
      await Auth.resendSignUp(payload.email)
      setCodeSent(true)
      setCodeMessage({
        message: `The code has been resent to ${payload.email}`,
        status: 'success',
      })
    } catch (error) {
      setCodeSent(false)
      if (error.message == 'User is already confirmed.')
        setCodeMessage({
          message:
            'Your account has already been confimed. Please try to login instead.',
          status: 'error',
        })
      else
        setCodeMessage({
          message: error.message,
          status: 'error',
        })
    } finally {
      setValidatingCode(false)
    }
  }

  const submit = async ({ code }) => {
    try {
      setLoading(true)
      if (payload.type == 'ForgotPassword')
        await Auth.forgotPasswordSubmit(payload.email, code, payload.password)
      else await Auth.confirmSignUp(payload.email, code)
      const credentials = {
        username: payload.email,
        password: payload.password,
      }
      await Auth.signIn(credentials)
      onSuccess()
    } catch (error) {
      if (error == 'User cannot be confirmed. User account status is CONFIRMED')
        form.setFields([
          {
            name: 'code',
            errors: [
              'Your account has already been created. Please try to login instead.',
            ],
          },
        ])
        const signOutUrl = `${process.env.REACT_APP_HOST_PATH}/logout`; // Or whichever URL you configured in Cognito's Allowed Sign-Out URLs
        await Auth.signOut({
            // --- FIX IS HERE ---
            global: true, // Optional: Sign out from all devices
            redirectUri: signOutUrl // CRITICAL: Tells Cognito where to send the user
            // --- END OF FIX ---
        });
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Form onFinish={submit} initialValues={{ code: '' }} form={form}>
        <Form.Item
          name="code"
          rules={[
            { required: true, message: 'Verification code is required.' },
          ]}
        >
          <Input label="Enter verification code" />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <Button
            htmlType="submit"
            loading={isLoading}
            type="primary"
            size="large"
            block
            style={{ height: '60px', marginTop: '10px' }}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
      <div className="footer">
        {isValidatingCode ? (
          <Text size={16}>Sending...</Text>
        ) : (
          <Text size={16}>
            Didn't receive it?{' '}
            <Text className="link-text" onClick={resendCode}>
              Resend Code
            </Text>
          </Text>
        )}
        {codeMessage.message != '' && (
          <Text className={`${codeMessage.status}-text`}>
            {codeMessage.message}
          </Text>
        )}
      </div>
    </>
  )
}
